import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { HttpService } from 'src/app/http.service';

import { Messages } from '../../constants/messages';

@Component({
  selector: 'app-accept-modal',
  templateUrl: './accept-modal.component.html',
  styleUrls: ['./accept-modal.component.scss']
})
export class AcceptModalComponent implements OnInit {
  acceptNumber: number;
  availableNumber = 0;

  columnsToDisplay: string[] = ['allocated', 'accepted'];

  acceptArr = [
    { availableVehicles: '2 free', reserve: '2' }
  ];

  orgDetails: any = {
    organizationName: '',
    orderNo: '',
    vehicleType: '',
    allocated: '',
    offeredPrice: '',
    distance: ''
  };

  location: any = {
    start: 'Mumbai',
    destination: 'Bangalore',
  };
  currencySymbol: any;
  vehicle = {
    _id: '',
    name: ''
  };
  messages = new Messages();
  isPallet = false;
  allocation_type = '';

  constructor(private dialog: MatDialogRef<AcceptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private snack: SnackbarService,
    private http: HttpService
  ) { }

  ngOnInit() {

    this.vehicle._id = this.parentData.order.vehicle._id;
    this.vehicle.name = this.parentData.order.vehicle.name;
    this.isPallet = this.parentData.order.uom === 'Pallets' ? true : false;
    this.allocation_type = this.parentData.order.allocation_type
    // if (!this.isPallet) {
    if (this.allocation_type == 'vehicle') {
      this.columnsToDisplay.unshift('availableVehicles');
    }
    this.getAvailableDrivers();
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;

    this.orgDetails = {
      organizationName: this.parentData.order.shipper.parent_name + ' - ' + this.parentData.order.shipper.name,
      orderNo: this.parentData.order.order,
      vehicleType: this.parentData.order.vehicle.name,
      allocated: this.parentData.allocated - this.parentData.cancelled,
      distance: (this.parentData.order.distance) ? this.parentData.order.distance : 'N/A',
      offeredPrice: (this.parentData.rate || this.parentData.rate_per_weight) ? Math.round(this.parentData.rate || this.parentData.rate_per_weight) : 'N/A',
      rate_type: this.parentData.rate_sub_type,
      isWeight: this.parentData.rate_per_weight ? true : false
    };
    if (this.parentData.uom === 'Pallets') {
      this.orgDetails.rate_type = 'pallet';
      this.orgDetails.offeredPrice = (this.parentData.rate || this.parentData.rate_per_pallet) ? Math.round(this.parentData.rate || this.parentData.rate_per_pallet) : 'N/A';
    }

    this.location = {
      start: this.parentData.order.from[0].loc_id.name,
      destination: this.parentData.order.to[this.parentData.order.to.length - 1].loc_id.name,
    };

  }

  closeAcceptModal(data = '') {
    this.dialog.close(data);
  }

  getAvailableDrivers() {
    // if (!this.isPallet) {
    if (this.allocation_type !== 'Pallets') {
      this.http.get('driver/get_all_attached', { vehicle_type: this.vehicle._id }).subscribe(
        (response: any) => {
          this.availableNumber = response.data.count;
        }
      );
    } else
      //if (this.isPallet) 
      if (this.allocation_type === 'Pallets') {
        this.http.get('driver/get_all_attached').subscribe(
          (response: any) => {
            this.availableNumber = response.data.count;
          }
        );
      }
  }
  number_test(n) {
    const result = (n - Math.floor(n)) !== 0;
    if (result) {
      return true;
    } else {
      return false;
    }
  }
  accept(temp: any, type = 'accept') {
    this.acceptNumber = temp;
    if (type == 'accept' && (this.acceptNumber <= 0 || !this.acceptNumber)) {
      this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.VALIDATION.ACCEPT_NUMBER, '', 'err');
      return;
    } else if (type == 'accept' && this.acceptNumber > (this.parentData.allocated - this.parentData.cancelled)) {
      this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.ACCEPT_NUMBER, '', 'err');
      return;
    } else {
      let url: any = '';
      const acceptData: any = {
        allocation_id: this.parentData.allocation_id,
      };
      // if (!this.isPallet) { 
      if (this.allocation_type == 'vehicle') {
        acceptData.accepted_veh = + this.acceptNumber;
        url = 'order/accept';
      }
      // if (this.isPallet) { 
      if (this.allocation_type == 'pallets') {
        acceptData.accepted_pallets = + this.acceptNumber;
        url = 'order/accept_pallets';
      }
      if (this.allocation_type == 'weight') {
        acceptData.accepted_weights = + this.acceptNumber;
        url = 'order/accept_weights';
      }
      this.http.post(url, acceptData).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            if (type == 'reject') {
              this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.SUCCESS.ORDER_REJECT);
              this.closeAcceptModal(data);
            } else if (type == 'accept') {
              this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.SUCCESS.ORDER_ACCEPT);
              this.closeAcceptModal(data);

            }
          } else {
            this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.TRY_AGAIN, '', 'err');
          }
        },
        (err: any) => {
          if (err.error.statusCode == 400 || err.error.statusCode == 403) {
            this.snack.openSnackBar(err.error.message, '', 'err');
          } else {
            this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.TRY_AGAIN, '', 'err');
          }
        }
      );
    }
  }
}
